// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","button__primary":"Button_button__primary__aHiDx","button__secondary":"Button_button__secondary__J5u7Z","button__small":"Button_button__small__tw2Ga"};